module.exports = __webpack_public_path__ + "static/media/groupIcon.0749f542.svg";